module.exports = __webpack_public_path__ + "img/sample20.ed4c9dad.jpg";